module.exports = __webpack_public_path__ + "img/Spinner@1x-1.0s-200px-200px.c9740ceb.svg";